// extracted by css-extract-rspack-plugin
export default {"root":"root-1tapB","default":"default-1Iejv","new":"new-3FATy","active":"active-2idZu","success":"success-1pnBG","warning":"warning-3C7rD","error":"error-3w16U"};